// Sticky Univeral Header 
document.addEventListener('DOMContentLoaded', function() {
  const mainHeader = document.querySelector('.shopify-section-header-sticky');
  const universalHeader = document.querySelector('.universal-header.custom-header');
  if (universalHeader && mainHeader){
    mainHeader.classList.add('universal-stuck');
  }
});